import { render, staticRenderFns } from "./SnackBarContainer.vue?vue&type=template&id=635316e5&scoped=true&"
import script from "./SnackBarContainer.vue?vue&type=script&lang=js&"
export * from "./SnackBarContainer.vue?vue&type=script&lang=js&"
import style0 from "./SnackBarContainer.vue?vue&type=style&index=0&id=635316e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635316e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VSnackbar})
